import * as React from 'react';

export const Paper = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9753 2.00049C14.0183 2.00049 14.0604 2.0041 14.1014 2.01105L14.2382 2.01189C14.4422 2.01189 14.6372 2.09489 14.7792 2.24189L19.8442 7.51889C19.9782 7.65789 20.0533 7.84489 20.0533 8.03789V17.2039C20.0712 19.7129 18.1172 21.7629 15.6042 21.8649L7.58522 21.8659H7.47622C5.02628 21.8105 3.06138 19.8291 3.00152 17.4031L3.00122 6.49089C3.05922 4.00989 5.10822 2.01189 7.57122 2.01189L13.8493 2.01105C13.8903 2.0041 13.9324 2.00049 13.9753 2.00049ZM13.2252 3.51149L7.57322 3.51189C5.91622 3.51189 4.54022 4.85389 4.50122 6.50889V17.2039C4.46422 18.9169 5.81422 20.3279 7.51022 20.3659H15.5742C17.2432 20.2969 18.5652 18.9099 18.5533 17.2099L18.5532 8.98349L16.5433 8.98449C14.7133 8.97949 13.2253 7.48749 13.2253 5.65949L13.2252 3.51149ZM13.7885 14.6086C14.2025 14.6086 14.5385 14.9446 14.5385 15.3586C14.5385 15.7726 14.2025 16.1086 13.7885 16.1086H8.38852C7.97452 16.1086 7.63852 15.7726 7.63852 15.3586C7.63852 14.9446 7.97452 14.6086 8.38852 14.6086H13.7885ZM11.7436 10.8566C12.1576 10.8566 12.4936 11.1926 12.4936 11.6066C12.4936 12.0206 12.1576 12.3566 11.7436 12.3566H8.38762C7.97362 12.3566 7.63762 12.0206 7.63762 11.6066C7.63762 11.1926 7.97362 10.8566 8.38762 10.8566H11.7436ZM14.7252 4.35249L14.7253 5.65949C14.7253 6.66349 15.5423 7.48149 16.5453 7.48449L17.7312 7.48349L14.7252 4.35249Z"
      fill="#64748B"
    />
  </svg>
);
